import Vue from "vue";
import Vuex from "vuex";
import { getEntryYear } from "@/utilities";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    selectedDate: "",
    formattedDate: "",
    selectedTours: Array(),
    visitorForm: {
      group_size: 1,
      firstname: "",
      lastname: "",
      email: "",
      confirm_email: "",
      note: "",
      phone: "",
      validated: false,
      alumni: false,
      faculty: [],
      optin: false,
      accessibility: "",
      international: "",
      entry_year: getEntryYear(),
    },
    showOverlay: false,
  },
  mutations: {
    updateSelectedDate(state, value) {
      state.selectedDate = value;
    },
    updateFormattedDate(state, value) {
      state.formattedDate = value;
    },
    updateSelectedTours(state, value) {
      state.selectedTours = value;
    },
    updateShowOverlay(state, value) {
      state.showOverlay = value;
    },
    // provide a tour object to remove from the selected list of tours.
    removeTour(state, value) {
      state.selectedTours = state.selectedTours.filter((t) => t !== value);
    },
  },
  modules: {},
});
